import { Form, Input } from 'antd'
import {
 useLazyGlobalSettingsQuery,
 useLazyWebSettingsQuery,
} from 'api/baseApi'
import { BaseButton } from 'components/elements/BaseButton'
import { BtnAnch, globalToaster } from 'components/elements/global'
import useAuth from 'hooks/useAuth'

import React, { FC, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { Link } from 'react-router-dom'
import { useLazyProfileQuery, useLoginMutation } from '../api'
import { LoginType } from '../types'

const Login: FC = () => {
 const { state: locationState } = useLocation() as unknown as Location & {
  state?: { from?: string }
 }

 const [login, { isLoading }] = useLoginMutation()
 //  const [getProfileMutation] = useGetProfileMutation()
 const [getGlobalSettingsMutation] = useLazyGlobalSettingsQuery()
 const [getProfileMutation] = useLazyProfileQuery()
 const [getWebSettings] = useLazyWebSettingsQuery()
 const { executeRecaptcha } = useGoogleReCaptcha()
 const [reLoading, setReLoading] = useState(false)

 const [form] = Form.useForm<LoginType>()

 const navigate = useNavigate()

 const HandleLogin = async (): Promise<void> => {
  const values = await form.validateFields()
  setReLoading(true)
  //   try {
  //    const token = await executeRecaptcha?.('login')
  //    //    const token = false
  //    await login({ ...values, ...(token ? { _recaptcha: token } : {}) }).unwrap()
  //    setReLoading(false)
  //    getProfileMutation?.()
  //    getGlobalSettingsMutation?.()
  //    window.location.reload()
  //   } catch (error) {
  //    setReLoading(false)
  //    globalToaster({ content: 'reCaptcha Error', type: 'error' })
  //   }

  executeRecaptcha?.('login')
   ?.then((token) => {
    login({ ...values, ...(token ? { _recaptcha: token } : {}) })
     ?.unwrap()
     ?.then(() => {
      getWebSettings()
       ?.unwrap()
       ?.then((res) => {
        setReLoading(false)
        getProfileMutation?.()
        getGlobalSettingsMutation?.()
        navigate(
         res?.onboarding_settings?.onboardShow?.first_open
          ? '/admin/user-onboard'
          : locationState?.from || '/admin/dashboard',
        )
       })
      // setReLoading(false)
      // getProfileMutation?.()
      // getGlobalSettingsMutation?.()
      // window.location.reload()
     })
     .catch(() => {
      setReLoading(false)
     })
   })
   .catch((err) => {
    console.log(err)
    setReLoading(false)
    globalToaster({ content: 'reCaptcha Error', type: 'error' })
   })
 }

 return (
  <div className="login-block">
   <div className="login-header">
    <h3>Login</h3>
   </div>
   <Form form={form}>
    <Form.Item
     name="email"
     rules={[
      { required: true, message: 'Enter the email' },
      { type: 'email', message: 'Enter the valid email' },
     ]}
    >
     <Input
      size="large"
      inputMode="email"
      placeholder="Enter Your Email"
      prefix={<i className="fas fa-envelope" />}
      type="email"
     />
    </Form.Item>
    <Form.Item
     className="mb-1"
     name="password"
     rules={[
      {
       required: true,
       message: 'Enter the password',
      },
     ]}
    >
     <Input.Password
      size="large"
      placeholder="Enter Your Password"
      prefix={<i className="fas fa-lock" />}
     />
    </Form.Item>

    <div className="forgot-pw-text-wrapper">
     <Link className="forgot-pw-text" to="/auth/reset-password">
      Forgot Password?
     </Link>
    </div>

    <BaseButton
     size="large"
     htmlType="submit"
     block
     buttonType="primary"
     onClick={HandleLogin}
     loading={isLoading || reLoading}
    >
     Login
    </BaseButton>
   </Form>
  </div>
 )
}

export default Login
